import React from "react";

export default function ReturnPolicy() {
  return <div>ReturnPolicy</div>;
}
